module.exports = __webpack_public_path__ + "static/media/eyecolor.a90086e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/icons/eyecolor.svg
// module id = 150
// module chunks = 0